import { IProjectTypeSettings } from '../../types';

export enum ProjectSettingsType {
    GET_PROJECT_SETTINGS = 'GET_PROJECT_SETTINGS',
    UPDATE_PROJECT_SETTINGS = 'UPDATE_PROJECT_SETTINGS',
    DELETE_PROJECT_SETTINGS = 'DELETE_PROJECT_SETTINGS',
    CREATE_PROJECT_SETTINGS = 'CREATE_PROJECT_SETTINGS',
    SET_CURRENT_PROJECT_TYPE_SETTINGS = 'SET_CURRENT_PROJECT_TYPE_SETTINGS',
}

export type RetrievedProjectSettings = {
    projectSettings: IProjectTypeSettings[];
    restrictedIntakeIds: string[];
};

interface GetProjectSettingsAction {
    type: ProjectSettingsType.GET_PROJECT_SETTINGS;
    payload: RetrievedProjectSettings;
}

interface UpdateProjectSettingsAction {
    type: ProjectSettingsType.UPDATE_PROJECT_SETTINGS;
    payload: IProjectTypeSettings;
}

interface DeleteProjectSettingsAction {
    type: ProjectSettingsType.DELETE_PROJECT_SETTINGS;
    payload: IProjectTypeSettings;
}

interface CreateProjectSettingsAction {
    type: ProjectSettingsType.CREATE_PROJECT_SETTINGS;
    payload: IProjectTypeSettings;
}

interface SetCurrentProjectTypeSettingsAction {
    type: ProjectSettingsType.SET_CURRENT_PROJECT_TYPE_SETTINGS;
    payload: {
        projectSettings: IProjectTypeSettings;
        restrictedIntakeIds: string[];
    };
}

export type ProjectSettingsAction =
    | GetProjectSettingsAction
    | UpdateProjectSettingsAction
    | CreateProjectSettingsAction
    | SetCurrentProjectTypeSettingsAction
    | DeleteProjectSettingsAction;
